import React, { useState } from 'react';
import { ChevronDown, Anchor, Triangle, Rocket, Target, Calendar, HeartPulse, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
const modules = [{
  id: 'M1',
  icon: Anchor,
  title: 'Fundamentos y Biomecánica Avanzada',
  tagline: 'La base que nadie te enseña',
  desc: 'Comprende la física detrás de cada movimiento. Aprende a posicionar tus escápulas, activar el core correctamente y generar tensión máxima para evitar lesiones y optimizar la fuerza.',
  bullets: ['Posicionamiento escapular preciso', 'Activación de core para tensión', 'Patrones biomecánicos correctos']
}, {
  id: 'M2',
  icon: Triangle,
  title: 'Dominando los Estáticos',
  tagline: 'Front, Back y Plancha',
  desc: 'El sistema paso a paso para desbloquear las palancas. Desde las progresiones iniciales (tuck) hasta el full form, con rutinas específicas de isometría y dinámicos accesorios.',
  bullets: ['Progresiones Tuck → Full Lever', 'Rutinas de isometría semanales', 'Accesorios para acelerar el truco']
}, {
  id: 'M3',
  icon: Rocket,
  title: 'Dinámicos y Explosividad',
  tagline: 'Muscle Up y transiciones',
  desc: 'Desarrolla la potencia necesaria para volar sobre la barra. Técnicas de kipping, false grip, y rutinas de explosividad para lograr un Muscle Up estricto y limpio.',
  bullets: ['False grip y agarre técnico', 'Drills explosivos por fase', 'Transición sobre la barra limpia']
}, {
  id: 'M4',
  icon: Target,
  title: 'Fuerza Estricta Unilateral',
  tagline: 'OAPU, HSPU, Pistol Squats',
  desc: 'Lleva tu fuerza al límite trabajando a un brazo o una pierna. Protocolos para dominar la dominada a un brazo, flexiones en pino y sentadillas a una pierna.',
  bullets: ['Progresiones para One Arm Pull Up', 'HSPU contra pared y libre', 'Pistol Squat con control total']
}, {
  id: 'M5',
  icon: Calendar,
  title: 'Planificación y Periodización',
  tagline: 'Tu calendario anual en casa',
  desc: 'Aprende a armar tu propio calendario anual. Cómo estructurar mesociclos, semanas de descarga, y autorregular el volumen según tu fatiga para no estancarte jamás.',
  bullets: ['Mesociclos de 4 a 8 semanas', 'Semanas de descarga estratégica', 'Autorregulación según fatiga']
}, {
  id: 'M6',
  icon: HeartPulse,
  title: 'Prevención, Movilidad y Flexibilidad',
  tagline: 'Articulaciones para toda la vida',
  desc: 'El secreto de la longevidad en calistenia. Rutinas de prehabilitación para hombros, codos y muñecas, junto con protocolos de flexibilidad para mejorar tu línea en los estáticos.',
  bullets: ['Prehab para hombros y codos', 'Movilidad de muñecas y cadera', 'Flexibilidad para línea perfecta']
}];
export function ModulesGrid() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 relative" data-id="element-161">
      {/* Background grid pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `linear-gradient(#FF6B1A 1px, transparent 1px), linear-gradient(90deg, #FF6B1A 1px, transparent 1px)`,
      backgroundSize: '60px 60px'
    }} data-id="element-162" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-163">
        <FadeIn className="text-center mb-8 md:mb-16" data-id="element-164">
          <div className="inline-flex items-center gap-2 bg-brand-orange/10 border border-brand-orange/30 text-brand-orange px-3 py-1 rounded-full text-xs font-bold tracking-widest mb-4" data-id="element-165">
            <Sparkles className="w-3 h-3" data-id="element-166" /> CONTENIDO COMPLETO
          </div>
          <h2 className="text-4xl md:text-7xl mb-2 md:mb-4" data-id="element-167">
            LOS 6 <span className="text-brand-orange" data-id="element-168">MÓDULOS</span>
          </h2>
          <p className="text-base md:text-xl text-brand-muted" data-id="element-169">
            Tu hoja de ruta para dominar la calistenia avanzada
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-170">
          {modules.map((mod, i) => {
          const Icon = mod.icon;
          const isOpen = openIndex === i;
          return <FadeIn key={i} delay={i * 0.05} data-id="element-171">
                <div className={`relative rounded-xl border overflow-hidden transition-all duration-300 h-full ${isOpen ? 'border-brand-orange bg-gradient-to-br from-brand-card to-brand-dark shadow-[0_0_30px_rgba(255,107,26,0.15)]' : 'border-brand-border bg-brand-card hover:border-brand-orange/40'}`} data-id="element-172">
                  {/* Orange accent line top */}
                  <div className={`h-1 transition-all duration-500 ${isOpen ? 'bg-brand-orange' : 'bg-brand-border'}`} data-id="element-173" />

                  <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full text-left p-4 md:p-5" aria-expanded={isOpen} data-id="element-174">
                    <div className="flex items-center gap-3 md:gap-4" data-id="element-175">
                      {/* Icon Badge */}
                      <div className={`relative shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-brand-orange text-white' : 'bg-brand-dark text-brand-orange border border-brand-border'}`} data-id="element-176">
                        <Icon className="w-5 h-5 md:w-6 md:h-6" data-id="element-177" />
                        <span className={`absolute -top-1.5 -right-1.5 font-display text-[10px] md:text-xs px-1.5 py-0.5 rounded ${isOpen ? 'bg-brand-dark text-brand-orange' : 'bg-brand-orange text-white'}`} data-id="element-178">
                          {mod.id}
                        </span>
                      </div>

                      {/* Title block */}
                      <div className="flex-grow min-w-0" data-id="element-179">
                        <h3 className="text-base md:text-lg font-bold leading-tight truncate" data-id="element-180">
                          {mod.title}
                        </h3>
                        <p className="text-xs md:text-sm text-brand-muted truncate" data-id="element-181">
                          {mod.tagline}
                        </p>
                      </div>

                      {/* Chevron */}
                      <ChevronDown className={`w-5 h-5 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brand-orange' : 'text-brand-muted'}`} data-id="element-182" />
                    </div>
                  </button>

                  {/* Expandable content */}
                  <AnimatePresence initial={false} data-id="element-183">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: 'easeOut'
                }} className="overflow-hidden" data-id="element-184">
                        <div className="px-4 md:px-5 pb-4 md:pb-5" data-id="element-185">
                          <div className="pt-3 border-t border-brand-border/50" data-id="element-186">
                            <p className="text-sm text-brand-muted leading-relaxed mb-3" data-id="element-187">
                              {mod.desc}
                            </p>
                            <ul className="space-y-1.5" data-id="element-188">
                              {mod.bullets.map((b, j) => <motion.li key={j} initial={{
                          opacity: 0,
                          x: -10
                        }} animate={{
                          opacity: 1,
                          x: 0
                        }} transition={{
                          delay: 0.1 + j * 0.05
                        }} className="flex items-center gap-2 text-xs md:text-sm" data-id="element-189">
                                  <div className="w-1.5 h-1.5 rounded-full bg-brand-orange shrink-0" data-id="element-190" />
                                  <span className="text-brand-text" data-id="element-191">{b}</span>
                                </motion.li>)}
                            </ul>
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.3} className="text-center mt-8 md:mt-12" data-id="element-192">
          <p className="text-sm md:text-base text-brand-muted" data-id="element-193">
            Tocá cada módulo para ver lo que incluye 👆
          </p>
        </FadeIn>
      </div>
    </section>;
}